import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DataStoreService } from './core/services/data-store.service';
import { OrgContextService } from './core/services/org-context.service';
import { UserService } from './core/services/user.service';
import { ThemeService } from './core/theme.service';
import { LanguageService } from './core/translation.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class App {
  private readonly dataStore = inject(DataStoreService);
  private readonly orgContext = inject(OrgContextService);
  private readonly userService = inject(UserService);
  private readonly language = inject(LanguageService);
  // Eager-instantiate theme service so the html class is set on first paint.
  private readonly theme = inject(ThemeService);

  constructor() {
    // Keep theme/language in sync with the user doc. The first snapshot fires
    // with the current Firestore value and supersedes the cached
    // localStorage/cookie preference; subsequent snapshots deliver
    // cross-tab/agent-driven changes. Also load the user doc so the sidebar
    // avatar and account page have profilePictureUrl available.
    effect(() => {
      const user = this.dataStore.authUser();
      if (user) {
        this.theme.startUserSync(user.uid);
        this.language.startUserSync(user.uid);
        this.userService.getCurrentUserDocument(true).catch(() => {});
      } else {
        this.theme.stopUserSync();
        this.language.stopUserSync();
        this.orgContext.stopCurrentOrgSync();
      }
    });
  }
}
